import { typeofbacteria_9P } from './pdfScoreConfig_9P.js';

// Mapping from full names to abbreviated names for 9P format
const bacteriaNameMapping_9P = {
    // Core bacteria
    // 'Akkermansia muciniphila': 'A. muciniphila',
    // 'Alistipes putredinis': 'A. putredinis',
    'Bacteroides genus': 'Bacteroides genus',
    // 'Bacteroides fragilis': 'B. fragilis',
    // 'Faecalibacterium prausnitzii': 'F. prausnitzii',
    // 'Roseburia hominis': 'R. hominis',
    
    // Harmful bacteria
    'Bacillus genus': 'Bacillus genus',
    'Candida albicans': 'C. albicans',
    'Clostridium difficile': 'C. difficile',
    'Escherichia coli': 'E. coli',
    'Staphylococcus aureus': 'S. aureus',
    
    // Beneficial bacteria
    'Bifidobacterium bifidum': 'B. bifidum',
    'Bifidobacterium breve': 'B. breve',
    'Bifidobacterium lactis': 'B. lactis',
    'Bifidobacterium longum': 'B. longum',
    'Lactobacillus acidophilus': 'L. acidophilus',
    'Lactobacillus gasseri': 'L. gasseri',
    'Lactobacillus helveticus': 'L. helveticus',
    'Lactobacillus paracasei': 'L. paracasei',
    'Lactobacillus plantarum': 'L. plantarum',
    'Lactobacillus reuteri': 'L. reuteri',
    'Lactobacillus rhamnosus': 'L. rhamnosus',
    'Streptococcus thermophilus': 'S. thermophilus'
};

// Configuration for displaying beneficial bacteria names when they are deficient or slightly deficient
export const pdfTextPreciseConfig_9P = {
    // Configuration for beneficial bacteria deficiency display
    beneficial_bacteria_deficiency: [
        {
            page: 14,
            version: 'eng',
            Xpostext: 290,
            Ypostext: 302,
            fontsize: 10,
            maxWidth: 240,
            condition: 'core_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 14,
            version: 'eng',
            Xpostext: 83,
            Ypostext: 485,
            fontsize: 10,
            maxWidth: 240,
            condition: 'beneficial_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        // {
        //     page: 14,
        //     version: 'eng',
        //     Xpostext: 290,
        //     Ypostext: 220,
        //     fontsize: 10,
        //     maxWidth: 210,
        //     condition: 'core_bacteria',
        //     target_labels: ['Deficient', 'Slightly Deficient'],
        //     description: ''
        // },
        {
            page: 14,
            version: 'eng',
            Xpostext: 287,
            Ypostext: 665,
            fontsize: 10,
            maxWidth: 240,
            condition: 'harmful_bacteria',
            target_labels: ['Excessive', 'Slightly Excessive'],
            description: ''
        },
        {
            page: 13,
            version: 'thai',
            Xpostext: 290,
            Ypostext: 309,
            fontsize: 10,
            maxWidth: 240,
            condition: 'core_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 13,
            version: 'thai',
            Xpostext: 83,
            Ypostext: 495,
            fontsize: 10,
            maxWidth: 240,
            condition: 'beneficial_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        // {
        //     page: 11,
        //     version: 'thai',
        //     Xpostext: 290,
        //     Ypostext: 225,
        //     fontsize: 10,
        //     maxWidth: 230,
        //     condition: 'core_bacteria',
        //     target_labels: ['Deficient', 'Slightly Deficient'],
        //     description: ''
        // },
        {
            page: 13,
            version: 'thai',
            Xpostext: 287,
            Ypostext: 672,
            fontsize: 10,
            maxWidth: 240,
            condition: 'harmful_bacteria',
            target_labels: ['Excessive', 'Slightly Excessive'],
            description: ''
        }
    ]
};

// Helper function to get deficient beneficial bacteria names
export const getDeficientBacteriaNames = (bacteriaResults, bacteriaType = 'beneficial_bacteria', targetLabels = ['Deficient', 'Slightly Deficient']) => {
    const bacteriaList = typeofbacteria_9P[bacteriaType] || [];
    const deficientBacteria = [];

    bacteriaList.forEach(bacteriaName => {
        const result = bacteriaResults[bacteriaName];
        if (result && targetLabels.includes(result.label)) {
            deficientBacteria.push(bacteriaName);
        }
    });

    return deficientBacteria;
};

// Helper function to format bacteria names for display with abbreviation mapping
export const formatBacteriaNames = (bacteriaNames) => {
    if (bacteriaNames.length === 0) {
        return 'None';
    }
    
    // Map full names to abbreviated names
    const abbreviatedNames = bacteriaNames.map(name => bacteriaNameMapping_9P[name] || name);
    return abbreviatedNames.join(', ');
};

// Helper function to get configuration for specific page and language
export const getTextConfigForPage = (pageNumber, language = 'eng') => {
    const configs = pdfTextPreciseConfig_9P.beneficial_bacteria_deficiency;
    return configs.find(config => config.page === pageNumber && config.version === language);
};
